const dev = {
  baseURL: "http://localhost:8073",
};

const prod = {
  baseURL: "https://demo.matjarepos.com",
};

const config = process.env.NODE_ENV === "production" ? prod : dev;

export default config;